import {
  IS_ACTIVE,
  UPDATE_INPUT_INTERVALS,
  UPDATE_REALTY_TRANSACTIONS,
  UPDATE_REALTY_TRANSACTIONS_FILTERS_ADD,
  CLEAR_FILTERS_TRANSACTIONS,
  UPDATE_BUILDING_DATA,
  UPDATE_REQUEST_STATUS_T,
  SET_INFOWINDOWS_TRANSACTIONS,
  ADD_INFOWINDOW_TRANSACTIONS,
  CLOSE_INFOWINDOW_TRANSACTIONS,
  SET_LAUNCHING_YEARS_TRANSACTIONS,
  UPDATE_PAYLOAD_CHARTS_TRANSACTIONS,
  UPDATE_CHARTS_DATA_TRANSACTIONS,
} from './realtyTransactions.actions';

//TODO: add more valid realtyTypes

const realtyTransactionsFiltersOptions = {
  realtyTypes: [
    { name: 'Apartamento', id: 'ap' },
    { name: 'Casa', id: 'cs' },
  ],
  timeframe: [
    { name: 'min', value: '' },
    { name: 'max', value: '' },
  ],
  privateAreaInterval: [
    { name: 'min', value: '' },
    { name: 'max', value: '' },
  ],
};

const initialFiltersTransactions = {
  realtyType: { name: 'Apartamento', id: 'ap' },
  inputIntervals: {
    timeframe: { min: '', max: '' },
    privateAreaInterval: { min: '', max: '' },
    realtyAge: { min: '', max: '' },
    // pricePerSquareMt: { min: '', max: '' },
  },
};

const initialBuildingDataState = {
  title: '',
  address: '',
  closing_date: '',
  table: [
    {
      total_units: '',
      total_transacted_units: '',
      area: '',
      transacted_2022: '',
      transacted_2019: '',
      transacted_2020: '',
      transacted_2018: '',
      transacted_percentual_2022: '',
      transacted_percentual_2019: '',
      transacted_percentual_2020: '',
      transacted_percentual_2018: '',
    },
  ],
  total: {
    total_units: '',
    total_transacted_units: '',
    transacted_percentual_2022: '',
    transacted_percentual_2019: '',
    transacted_percentual_2020: '',
    transacted_percentual_2018: '',
    total_transacted_2022: '',
    total_transacted_2019: '',
    total_transacted_2020: '',
    total_transacted_2018: '',
  },
};

const initialState = {
  realtyTransactionsFiltersOptions,
  realtyTransactions: JSON.parse(JSON.stringify(initialFiltersTransactions)),
  realtyTransactionsFiltersAdd: {
    filterAddT: false,
    tabSelect: 'realtyTransactions',
  },
  newAlertName: '',
  isActive: {
    sidebar: true,
    menuAction: '',
    mapAction: '',
    results: false,
  },
  userInput: {
    building: '',
    company: '',
  },
  payloadChartsTransactions: [],
  buildingData: initialBuildingDataState,
  infoWindowsTransactions: [],
  launchingYearsTransactions: [],
  requestStatusT: {
    transactionedOverExistingRealties: 'LOADED',
  },
  chartsDataTransactions: {
    transactioned_over_existing_realties: [],
  },
};

export default function realtyTransactionsReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case IS_ACTIVE:
      return {
        ...state,
        isActive: { ...state.isActive, [payload.name]: payload.value },
      };
    case UPDATE_PAYLOAD_CHARTS_TRANSACTIONS:
      return {
        ...state,
        payloadChartsTransactions: payload,
      };
    case UPDATE_INPUT_INTERVALS:
      return {
        ...state,
        realtyTransactions: {
          ...state.realtyTransactions,
          inputIntervals: {
            ...state.realtyTransactions.inputIntervals,
            [payload.name]: payload.value,
          },
        },
      };
    case UPDATE_REALTY_TRANSACTIONS:
      return {
        ...state,
        realtyTransactions: {
          ...state.realtyTransactions,
          [payload.name]: payload.value,
        },
      };
    case UPDATE_REALTY_TRANSACTIONS_FILTERS_ADD:
      return {
        ...state,
        realtyTransactionsFiltersAdd: {
          ...state.realtyTransactionsFiltersAdd,
          [payload.name]: payload.value,
        },
      };
    case CLEAR_FILTERS_TRANSACTIONS:
      return {
        ...state,
        realtyTransactions: {
          realtyType: { name: 'Apartamento', id: 'ap' },
          inputIntervals: JSON.parse(
            JSON.stringify(initialFiltersTransactions.inputIntervals)
          ),
        },
      };
    case UPDATE_BUILDING_DATA:
      return { ...state, buildingData: { ...state.buildingData, ...payload } };
    case UPDATE_REQUEST_STATUS_T:
      return {
        ...state,
        requestStatusT: {
          ...state.requestStatusT,
          [payload.name]: payload.value,
        },
      };
    case SET_INFOWINDOWS_TRANSACTIONS:
      return { ...state, infoWindowsTransactions: payload };
    case ADD_INFOWINDOW_TRANSACTIONS:
      return {
        ...state,
        infoWindowsTransactions: [...state.infoWindowsTransactions, payload],
      };
    case CLOSE_INFOWINDOW_TRANSACTIONS:
      state.infoWindowsTransactions?.forEach((el) => el.close());
      return state;
    case SET_LAUNCHING_YEARS_TRANSACTIONS:
      return { ...state, launchingYearsTransactions: payload };
    case UPDATE_CHARTS_DATA_TRANSACTIONS:
      return {
        ...state,
        chartsDataTransactions: {
          ...state.chartsDataTransactions,
          [payload.name]: payload.value,
        },
      };
    default:
      return state;
  }
}
